import StyledLink from '../StyledLink'
import makeUrl from './makeUrl/makeUrl'
import useModule from '../../hooks/useModule'
import {
  CONTROLLER,
  MONITOR,
  MONITOR_CONFIG,
  TEST_CONFIG
} from '../routes'
import type { Props } from '../types'

interface Params {
  testConfigId: string
  tab?: 0 | 1 | 2
}

const LinkToEditTestConfig = ({
  children,
  testConfigId,
  isHyperlink,
  tab
}: (Props & Params)) => {
  const [isMonitorFlag] = useModule()

  const base = !isMonitorFlag
    ? '/' + CONTROLLER + '/' + TEST_CONFIG + '/' + testConfigId
    : '/' + MONITOR + '/' + MONITOR_CONFIG + '/' + testConfigId

  const tabQueryParam = { tab }

  const url = tab
    ? makeUrl(base, tabQueryParam)
    : base

  return (
    <StyledLink
      isHyperlink={isHyperlink}
      to={url}
    >
      {children}
    </StyledLink>
  )
}

export default LinkToEditTestConfig
